import './JewelleryOptionsStrap.svelte.css';
/* src/components/JewelleryOptions/JewelleryOptionsStrap.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_data,
	set_style,
	space,
	src_url_equal,
	text
} from "../../../_snowpack/pkg/svelte/internal.js";

import { onMount } from '../../../_snowpack/pkg/svelte.js';

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[20] = list[i];
	child_ctx[22] = i;
	return child_ctx;
}

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[20] = list[i];
	child_ctx[22] = i;
	return child_ctx;
}

// (103:37) 
function create_if_block_2(ctx) {
	let strong;
	let t1;
	let ul;
	let li0;
	let img0;
	let img0_src_value;
	let t2;
	let span0;
	let t3;
	let t4_value = /*selectedPartsF*/ ctx[7].name + "";
	let t4;
	let t5;
	let li1;
	let img1;
	let img1_src_value;
	let t6;
	let span1;
	let t7;
	let t8_value = /*selectedPartsE*/ ctx[8].name + "";
	let t8;
	let t9;
	let li2;
	let img2;
	let img2_src_value;
	let t10;
	let form;
	let div;
	let button0;
	let t12;
	let input0;
	let t13;
	let input1;
	let input1_value_value;
	let t14;
	let input2;
	let t15;
	let input3;
	let t16;
	let button1;
	let mounted;
	let dispose;

	return {
		c() {
			strong = element("strong");
			strong.textContent = "③紐色、金具をご確認のうえ、よろしければ「カートに入れる」ボタンをクリックしてください。";
			t1 = space();
			ul = element("ul");
			li0 = element("li");
			img0 = element("img");
			t2 = space();
			span0 = element("span");
			t3 = text("紐色:");
			t4 = text(t4_value);
			t5 = space();
			li1 = element("li");
			img1 = element("img");
			t6 = space();
			span1 = element("span");
			t7 = text("金具:");
			t8 = text(t8_value);
			t9 = space();
			li2 = element("li");
			img2 = element("img");
			t10 = space();
			form = element("form");
			div = element("div");
			button0 = element("button");
			button0.textContent = "戻る";
			t12 = space();
			input0 = element("input");
			t13 = space();
			input1 = element("input");
			t14 = space();
			input2 = element("input");
			t15 = space();
			input3 = element("input");
			t16 = space();
			button1 = element("button");
			button1.textContent = "カートに入れる";
			if (!src_url_equal(img0.src, img0_src_value = /*selectedPartsF*/ ctx[7].srcS)) attr(img0, "src", img0_src_value);
			attr(img0, "alt", "紐色");
			attr(img0, "class", "svelte-1okd4od");
			attr(li0, "class", "selected-strap svelte-1okd4od");
			if (!src_url_equal(img1.src, img1_src_value = /*selectedPartsE*/ ctx[8].srcS)) attr(img1, "src", img1_src_value);
			attr(img1, "alt", "金具");
			attr(img1, "class", "svelte-1okd4od");
			attr(li1, "class", "selected-ballchip svelte-1okd4od");
			attr(img2, "loading", "lazy");
			attr(img2, "alt", "preview");
			if (!src_url_equal(img2.src, img2_src_value = "" + (/*parts*/ ctx[0].root + "itemimage?row=strap4&lit_option_data=" + /*selectedPartsF*/ ctx[7].id + "," + /*selectedPartsE*/ ctx[8].id + "," + /*parts*/ ctx[0].code))) attr(img2, "src", img2_src_value);
			attr(img2, "class", "svelte-1okd4od");
			attr(li2, "class", "preview-image svelte-1okd4od");
			set_style(li2, "background-image", "url(" + /*imgBG*/ ctx[9] + ")");
			attr(ul, "class", "strap-preview svelte-1okd4od");
			attr(button0, "class", "lit-gradient-button gradient-gray");
			attr(input0, "type", "hidden");
			attr(input0, "name", "add-to-cart");
			input0.value = "8606";
			attr(input1, "id", "lit_bto_code");
			attr(input1, "type", "hidden");
			input1.value = input1_value_value = /*parts*/ ctx[0].code;
			attr(input1, "name", "item_code");
			attr(input2, "id", "lit_bto_row");
			attr(input2, "type", "hidden");
			input2.value = /*selectedPartsList*/ ctx[5];
			attr(input2, "name", "row_data");
			attr(input3, "type", "hidden");
			input3.value = "cart_in";
			attr(input3, "name", "litAction");
			attr(button1, "class", "lit-gradient-button next svelte-1okd4od");
			attr(button1, "type", "submit");
			attr(div, "class", "paging svelte-1okd4od");
			attr(form, "enctype", "multipart/form-data");
			attr(form, "action", /*cartInAction*/ ctx[10]);
			attr(form, "method", "post");
		},
		m(target, anchor) {
			insert(target, strong, anchor);
			insert(target, t1, anchor);
			insert(target, ul, anchor);
			append(ul, li0);
			append(li0, img0);
			append(li0, t2);
			append(li0, span0);
			append(span0, t3);
			append(span0, t4);
			append(ul, t5);
			append(ul, li1);
			append(li1, img1);
			append(li1, t6);
			append(li1, span1);
			append(span1, t7);
			append(span1, t8);
			append(ul, t9);
			append(ul, li2);
			append(li2, img2);
			insert(target, t10, anchor);
			insert(target, form, anchor);
			append(form, div);
			append(div, button0);
			append(div, t12);
			append(div, input0);
			append(div, t13);
			append(div, input1);
			append(div, t14);
			append(div, input2);
			append(div, t15);
			append(div, input3);
			append(div, t16);
			append(div, button1);

			if (!mounted) {
				dispose = listen(button0, "click", /*click_handler_3*/ ctx[19]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*selectedPartsF*/ 128 && !src_url_equal(img0.src, img0_src_value = /*selectedPartsF*/ ctx[7].srcS)) {
				attr(img0, "src", img0_src_value);
			}

			if (dirty & /*selectedPartsF*/ 128 && t4_value !== (t4_value = /*selectedPartsF*/ ctx[7].name + "")) set_data(t4, t4_value);

			if (dirty & /*selectedPartsE*/ 256 && !src_url_equal(img1.src, img1_src_value = /*selectedPartsE*/ ctx[8].srcS)) {
				attr(img1, "src", img1_src_value);
			}

			if (dirty & /*selectedPartsE*/ 256 && t8_value !== (t8_value = /*selectedPartsE*/ ctx[8].name + "")) set_data(t8, t8_value);

			if (dirty & /*parts, selectedPartsF, selectedPartsE*/ 385 && !src_url_equal(img2.src, img2_src_value = "" + (/*parts*/ ctx[0].root + "itemimage?row=strap4&lit_option_data=" + /*selectedPartsF*/ ctx[7].id + "," + /*selectedPartsE*/ ctx[8].id + "," + /*parts*/ ctx[0].code))) {
				attr(img2, "src", img2_src_value);
			}

			if (dirty & /*parts*/ 1 && input1_value_value !== (input1_value_value = /*parts*/ ctx[0].code)) {
				input1.value = input1_value_value;
			}

			if (dirty & /*selectedPartsList*/ 32) {
				input2.value = /*selectedPartsList*/ ctx[5];
			}
		},
		d(detaching) {
			if (detaching) detach(strong);
			if (detaching) detach(t1);
			if (detaching) detach(ul);
			if (detaching) detach(t10);
			if (detaching) detach(form);
			mounted = false;
			dispose();
		}
	};
}

// (60:31) 
function create_if_block_1(ctx) {
	let strong;
	let t1;
	let div0;
	let img;
	let img_src_value;
	let t2;
	let div1;
	let button0;
	let t4;
	let button1;
	let t6;
	let ul;
	let mounted;
	let dispose;
	let each_value_1 = /*parts*/ ctx[0].e;
	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	return {
		c() {
			strong = element("strong");
			strong.textContent = "②金具を選択してください。";
			t1 = space();
			div0 = element("div");
			img = element("img");
			t2 = space();
			div1 = element("div");
			button0 = element("button");
			button0.textContent = "戻る";
			t4 = space();
			button1 = element("button");
			button1.textContent = "次へ";
			t6 = space();
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			if (!src_url_equal(img.src, img_src_value = /*selectedPartsE*/ ctx[8].srcM.replace('jewelbox/img/', 'jewelbox/img_l/'))) attr(img, "src", img_src_value);
			attr(img, "alt", "img");
			attr(img, "class", "svelte-1okd4od");
			attr(div0, "class", "parts-image svelte-1okd4od");
			attr(button0, "class", "lit-gradient-button gradient-gray prev svelte-1okd4od");
			attr(button1, "class", "lit-gradient-button next svelte-1okd4od");
			attr(div1, "class", "paging svelte-1okd4od");
			attr(ul, "class", "parts-list svelte-1okd4od");
		},
		m(target, anchor) {
			insert(target, strong, anchor);
			insert(target, t1, anchor);
			insert(target, div0, anchor);
			append(div0, img);
			insert(target, t2, anchor);
			insert(target, div1, anchor);
			append(div1, button0);
			append(div1, t4);
			append(div1, button1);
			insert(target, t6, anchor);
			insert(target, ul, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}

			if (!mounted) {
				dispose = [
					listen(button0, "click", /*click_handler_1*/ ctx[15]),
					listen(button1, "click", /*click_handler_2*/ ctx[16])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*selectedPartsE*/ 256 && !src_url_equal(img.src, img_src_value = /*selectedPartsE*/ ctx[8].srcM.replace('jewelbox/img/', 'jewelbox/img_l/'))) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*parts, keyEs, keyE, selectedPartsList*/ 51) {
				each_value_1 = /*parts*/ ctx[0].e;
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(ul, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value_1.length;
			}
		},
		d(detaching) {
			if (detaching) detach(strong);
			if (detaching) detach(t1);
			if (detaching) detach(div0);
			if (detaching) detach(t2);
			if (detaching) detach(div1);
			if (detaching) detach(t6);
			if (detaching) detach(ul);
			destroy_each(each_blocks, detaching);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (26:1) {#if 'f' === currentPage}
function create_if_block(ctx) {
	let strong;
	let t1;
	let div0;
	let img;
	let img_src_value;
	let t2;
	let div1;
	let button;
	let t4;
	let ul;
	let mounted;
	let dispose;
	let each_value = /*parts*/ ctx[0].f;
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			strong = element("strong");
			strong.textContent = "①紐色を選択してください。";
			t1 = space();
			div0 = element("div");
			img = element("img");
			t2 = space();
			div1 = element("div");
			button = element("button");
			button.textContent = "次へ";
			t4 = space();
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			if (!src_url_equal(img.src, img_src_value = /*selectedPartsF*/ ctx[7].srcM)) attr(img, "src", img_src_value);
			attr(img, "alt", "img");
			attr(img, "class", "svelte-1okd4od");
			attr(div0, "class", "parts-image svelte-1okd4od");
			attr(button, "class", "lit-gradient-button next svelte-1okd4od");
			attr(div1, "class", "paging svelte-1okd4od");
			attr(ul, "class", "parts-list svelte-1okd4od");
		},
		m(target, anchor) {
			insert(target, strong, anchor);
			insert(target, t1, anchor);
			insert(target, div0, anchor);
			append(div0, img);
			insert(target, t2, anchor);
			insert(target, div1, anchor);
			append(div1, button);
			insert(target, t4, anchor);
			insert(target, ul, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}

			if (!mounted) {
				dispose = listen(button, "click", /*click_handler*/ ctx[11]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*selectedPartsF*/ 128 && !src_url_equal(img.src, img_src_value = /*selectedPartsF*/ ctx[7].srcM)) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*parts, keyFs, keyF, selectedPartsList*/ 45) {
				each_value = /*parts*/ ctx[0].f;
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(ul, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		d(detaching) {
			if (detaching) detach(strong);
			if (detaching) detach(t1);
			if (detaching) detach(div0);
			if (detaching) detach(t2);
			if (detaching) detach(div1);
			if (detaching) detach(t4);
			if (detaching) detach(ul);
			destroy_each(each_blocks, detaching);
			mounted = false;
			dispose();
		}
	};
}

// (83:3) {#each parts.e as item, index}
function create_each_block_1(ctx) {
	let li;
	let input;
	let input_id_value;
	let input_value_value;
	let t0;
	let label;
	let img;
	let img_src_value;
	let t1;
	let span;
	let t2_value = /*item*/ ctx[20].name.replace('（', '\n（') + "";
	let t2;
	let label_for_value;
	let t3;
	let mounted;
	let dispose;

	function change_handler_1() {
		return /*change_handler_1*/ ctx[18](/*index*/ ctx[22], /*item*/ ctx[20]);
	}

	return {
		c() {
			li = element("li");
			input = element("input");
			t0 = space();
			label = element("label");
			img = element("img");
			t1 = space();
			span = element("span");
			t2 = text(t2_value);
			t3 = space();
			attr(input, "type", "radio");
			attr(input, "name", "litSelectStrap");
			attr(input, "id", input_id_value = /*item*/ ctx[20].id);
			input.__value = input_value_value = /*item*/ ctx[20].id;
			input.value = input.__value;
			/*$$binding_groups*/ ctx[13][1].push(input);
			if (!src_url_equal(img.src, img_src_value = /*item*/ ctx[20].srcS)) attr(img, "src", img_src_value);
			attr(img, "alt", "checkbox");
			attr(img, "class", "svelte-1okd4od");
			attr(label, "for", label_for_value = /*item*/ ctx[20].id);
			attr(label, "class", "svelte-1okd4od");
			attr(li, "class", " svelte-1okd4od");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, input);
			input.checked = input.__value === /*keyEs*/ ctx[4];
			append(li, t0);
			append(li, label);
			append(label, img);
			append(label, t1);
			append(label, span);
			append(span, t2);
			append(li, t3);

			if (!mounted) {
				dispose = [
					listen(input, "change", /*input_change_handler_1*/ ctx[17]),
					listen(input, "change", change_handler_1)
				];

				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty & /*parts*/ 1 && input_id_value !== (input_id_value = /*item*/ ctx[20].id)) {
				attr(input, "id", input_id_value);
			}

			if (dirty & /*parts*/ 1 && input_value_value !== (input_value_value = /*item*/ ctx[20].id)) {
				input.__value = input_value_value;
				input.value = input.__value;
			}

			if (dirty & /*keyEs*/ 16) {
				input.checked = input.__value === /*keyEs*/ ctx[4];
			}

			if (dirty & /*parts*/ 1 && !src_url_equal(img.src, img_src_value = /*item*/ ctx[20].srcS)) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*parts*/ 1 && t2_value !== (t2_value = /*item*/ ctx[20].name.replace('（', '\n（') + "")) set_data(t2, t2_value);

			if (dirty & /*parts*/ 1 && label_for_value !== (label_for_value = /*item*/ ctx[20].id)) {
				attr(label, "for", label_for_value);
			}
		},
		d(detaching) {
			if (detaching) detach(li);
			/*$$binding_groups*/ ctx[13][1].splice(/*$$binding_groups*/ ctx[13][1].indexOf(input), 1);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (40:3) {#each parts.f as item, index}
function create_each_block(ctx) {
	let li;
	let input;
	let input_id_value;
	let input_value_value;
	let t0;
	let label;
	let img;
	let img_src_value;
	let t1;
	let span;
	let t2_value = /*item*/ ctx[20].name + "";
	let t2;
	let label_for_value;
	let t3;
	let mounted;
	let dispose;

	function change_handler() {
		return /*change_handler*/ ctx[14](/*index*/ ctx[22], /*item*/ ctx[20]);
	}

	return {
		c() {
			li = element("li");
			input = element("input");
			t0 = space();
			label = element("label");
			img = element("img");
			t1 = space();
			span = element("span");
			t2 = text(t2_value);
			t3 = space();
			attr(input, "type", "radio");
			attr(input, "name", "litSelectStrap");
			attr(input, "id", input_id_value = /*item*/ ctx[20].id);
			input.__value = input_value_value = /*item*/ ctx[20].id;
			input.value = input.__value;
			/*$$binding_groups*/ ctx[13][0].push(input);
			if (!src_url_equal(img.src, img_src_value = /*item*/ ctx[20].srcS)) attr(img, "src", img_src_value);
			attr(img, "alt", "checkbox");
			attr(img, "class", "svelte-1okd4od");
			attr(label, "for", label_for_value = /*item*/ ctx[20].id);
			attr(label, "class", "svelte-1okd4od");
			attr(li, "class", " svelte-1okd4od");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, input);
			input.checked = input.__value === /*keyFs*/ ctx[3];
			append(li, t0);
			append(li, label);
			append(label, img);
			append(label, t1);
			append(label, span);
			append(span, t2);
			append(li, t3);

			if (!mounted) {
				dispose = [
					listen(input, "change", /*input_change_handler*/ ctx[12]),
					listen(input, "change", change_handler)
				];

				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty & /*parts*/ 1 && input_id_value !== (input_id_value = /*item*/ ctx[20].id)) {
				attr(input, "id", input_id_value);
			}

			if (dirty & /*parts*/ 1 && input_value_value !== (input_value_value = /*item*/ ctx[20].id)) {
				input.__value = input_value_value;
				input.value = input.__value;
			}

			if (dirty & /*keyFs*/ 8) {
				input.checked = input.__value === /*keyFs*/ ctx[3];
			}

			if (dirty & /*parts*/ 1 && !src_url_equal(img.src, img_src_value = /*item*/ ctx[20].srcS)) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*parts*/ 1 && t2_value !== (t2_value = /*item*/ ctx[20].name + "")) set_data(t2, t2_value);

			if (dirty & /*parts*/ 1 && label_for_value !== (label_for_value = /*item*/ ctx[20].id)) {
				attr(label, "for", label_for_value);
			}
		},
		d(detaching) {
			if (detaching) detach(li);
			/*$$binding_groups*/ ctx[13][0].splice(/*$$binding_groups*/ ctx[13][0].indexOf(input), 1);
			mounted = false;
			run_all(dispose);
		}
	};
}

function create_fragment(ctx) {
	let div;

	function select_block_type(ctx, dirty) {
		if ('f' === /*currentPage*/ ctx[6]) return create_if_block;
		if ('e' === /*currentPage*/ ctx[6]) return create_if_block_1;
		if ('preview' === /*currentPage*/ ctx[6]) return create_if_block_2;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type && current_block_type(ctx);

	return {
		c() {
			div = element("div");
			if (if_block) if_block.c();
			attr(div, "class", "strap-parts-select svelte-1okd4od");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block) if_block.m(div, null);
		},
		p(ctx, [dirty]) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if (if_block) if_block.d(1);
				if_block = current_block_type && current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(div, null);
				}
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);

			if (if_block) {
				if_block.d();
			}
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let selectedPartsE;
	let selectedPartsF;
	let { parts } = $$props;
	let keyE = 0;
	let keyF = 0;
	let keyFs;
	let keyEs;
	let selectedPartsList = [];
	let currentPage = 'f';
	let imgBG = parts.root + 'img/lithos_philia/common/loading.gif';
	let cartInAction = parts.root + '/cart/';

	onMount(() => {
		$$invalidate(5, selectedPartsList = parts.currentparts);
		$$invalidate(3, keyFs = parts.f[0].id);
		$$invalidate(4, keyEs = parts.e[0].id);
	});

	const $$binding_groups = [[], []];

	const click_handler = () => {
		$$invalidate(6, currentPage = 'e');
	};

	function input_change_handler() {
		keyFs = this.__value;
		$$invalidate(3, keyFs);
	}

	const change_handler = (index, item) => {
		$$invalidate(2, keyF = index);
		$$invalidate(5, selectedPartsList[0] = item.id, selectedPartsList);
	};

	const click_handler_1 = () => {
		$$invalidate(6, currentPage = 'f');
	};

	const click_handler_2 = () => {
		$$invalidate(6, currentPage = 'preview');
	};

	function input_change_handler_1() {
		keyEs = this.__value;
		$$invalidate(4, keyEs);
	}

	const change_handler_1 = (index, item) => {
		$$invalidate(1, keyE = index);
		$$invalidate(5, selectedPartsList[1] = item.id, selectedPartsList);
	};

	const click_handler_3 = () => {
		$$invalidate(6, currentPage = 'e');
	};

	$$self.$$set = $$props => {
		if ('parts' in $$props) $$invalidate(0, parts = $$props.parts);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*parts, keyE*/ 3) {
			$: $$invalidate(8, selectedPartsE = parts.e[keyE]);
		}

		if ($$self.$$.dirty & /*parts, keyF*/ 5) {
			$: $$invalidate(7, selectedPartsF = parts.f[keyF]);
		}
	};

	return [
		parts,
		keyE,
		keyF,
		keyFs,
		keyEs,
		selectedPartsList,
		currentPage,
		selectedPartsF,
		selectedPartsE,
		imgBG,
		cartInAction,
		click_handler,
		input_change_handler,
		$$binding_groups,
		change_handler,
		click_handler_1,
		click_handler_2,
		input_change_handler_1,
		change_handler_1,
		click_handler_3
	];
}

class JewelleryOptionsStrap extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { parts: 0 });
	}
}

export default JewelleryOptionsStrap;